export const JSONParse = <T>(jsonString): T | null => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return JSON.parse(jsonString);
  } catch (error) {
    return null;
  }
};
